import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { finalize, map, startWith } from 'rxjs/operators';
import { FotografiasService } from '../../services/fotografias.service';
import { VerFotoComponent } from './ver-foto/ver-foto.component';

@Component({
	selector: 'kt-fotografias',
	templateUrl: './fotografias.component.html',
	styleUrls: ['./fotografias.component.scss']
})
export class FotografiasComponent implements OnInit {
	public imeiList: string[] = [];
	public imagesList = [];
	public imeiControl = new FormControl();
	public mensajeAgrupar: string = "Arrastre un encabezado de columna aquí para agrupar por esa columna"

	public showFilterRow: boolean;
	public showHeaderFilter: boolean;
	public filterValue: string;
	public filteredOptions: Observable<string[]>;

	public loadingVisible: boolean = false;

	constructor(private fotografiasService: FotografiasService,
		private dialog: MatDialog,
		private toastService: ToastrService,
		private datepipe: DatePipe,
		private router: Router) {
		this.showFilterRow = true;
		this.showHeaderFilter = true;
	}

	ngOnInit() {
		this.getImeiList();
		this.filteredOptions = this.imeiControl.valueChanges.pipe(
			startWith(''),
			map(value => this._filter(value))
		);
	}


	private _filter(name: string): string[] {
		const filterValue = name.toLowerCase();
		return this.imeiList.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
	}

	getImeiList() {
		this.fotografiasService.getImeiList().subscribe(
			(imeis: string[]) => {
				this.imeiList = imeis;
			}, (err) => {
				console.log('Error al obtener imeis');

			}
		)
	}

	getImagesList() {
		this.loadingVisible = true;
		const imei = this.imeiControl.value;
		const today = new Date();
		this.filterValue = this.datepipe.transform(today, 'dd/MM/yy');

		this.fotografiasService.getImagesList(imei).pipe(
			finalize(
				() => this.loadingVisible = false
			)
		).subscribe(
			(images: string[]) => {
				if (images.length > 0) {
					images.forEach(image => {
						let data = image.split(' ');
						let id = data[0].substring(0, data[0].length - 1)
						let imageData = {
							id: id,
							fecha: data[2],
							hora: data[3] + ' ' + data[4]
						}
						this.imagesList.push(imageData);
					});
				} else {
					this.toastService.warning('No hay imagenes para mostrar');
				}


			}, (err) => {
				console.log('Error al obtener lista de imagenes');

			}
		)
	}

	getImage(imagenData) {
		this.loadingVisible = true;
		this.fotografiasService.getImage(this.imeiControl.value, imagenData.id).pipe(
			finalize(
				() => {
					this.loadingVisible = false
				}
			)
		).subscribe(
			(imagen) => {
				const data = {
					id: imagenData.id,
					imei: this.imeiControl.value,
					fechaHora: imagenData.fecha + ' ' + imagenData.hora,
					imagen: window.URL.createObjectURL(imagen)
				}

				const dialogConfig = new MatDialogConfig();
				dialogConfig.autoFocus = true;
				dialogConfig.disableClose = true;
				dialogConfig.width = "30%";
				dialogConfig.closeOnNavigation = true;
				dialogConfig.hasBackdrop = false;
				dialogConfig.panelClass = 'custom-modalbox';
				dialogConfig.data = data
				this.dialog.open(VerFotoComponent, dialogConfig).afterClosed().subscribe(() => {
				});

			}, (err) => {
				this.toastService.error('Error al obtener imagen');

			}
		);
	}

	regresar() {
		this.router.navigateByUrl('/home/administracion/consola/alertados');
	}



}
